export default "__VITE_ASSET__029c95ba__"